import React, { useContext, useEffect, useState } from 'react'
import DescricaoDoProjetoOuInvestimento from './DescricaoDoProjetoOuInvestimento'
import MotivadorDoCapexNaoPrevisto from './MotivadorDoCapexNaoPrevisto'
import Orcamento from './Orcamento'
import RecursosParaExecucao from './RecursosParaExecucao'
import Detalhes from './Detalhes'
import ValidacoesAprovacoes from './ValidacoesAprovacoes'
import { useRecoilValue } from 'recoil'
import { aprovacoesSolicitacaoState, solicitacaoIdState } from '../../../atoms'
import { Visibility } from '@app/components/Visibility'
import { FormContext, notification } from '@digital/ui'
import { isObjNotEmpty } from '@app/helpers/objHelper'
import OrcamentoFinanceiro from './OrcamentoFinanceiro'
import { getOrcamentoSolicitacaoNaoPrevisto, OrcamentoSolicitacaoNaoPrevisto } from '@app/api/naoPrevistos/orcamentoSolicitacao'
import { getAllAcronimosPacote } from '@app/api/acronimosPacote'
import { getAllCrfContaContabil } from '@app/api/crf/contaContabil'

interface IStepPreenchimentoTipoSolicitacaoProps {
}

const StepPreenchimentoTipoSolicitacao = ({ }: IStepPreenchimentoTipoSolicitacaoProps) => {
  const { formProps } = useContext(FormContext);
  const aprovacoesSolicitacao = useRecoilValue(aprovacoesSolicitacaoState);
  const [list, setList] = useState<OrcamentoSolicitacaoNaoPrevisto[]>([])
  const [orcamentos, setOrcamentos] = useState<OrcamentoSolicitacaoNaoPrevisto[]>([])
  const [acronimos, setAcronimos] = useState([])
  const [contasContabil, setContasContabil] = useState([])
  const idSolicitacao = useRecoilValue(solicitacaoIdState);


  useEffect(() => {
    if (idSolicitacao !== undefined) {
      getOrcamentoSolicitacaoNaoPrevisto(idSolicitacao).then((response) => {
        if (response) {
          const newOrcamentoList = response.map((item) => {
            return { ...item }
          })
          setList([...response])
          setOrcamentos(newOrcamentoList)
        }
      })
    }
  }, [idSolicitacao])


  useEffect(() => {
    if (formProps) {
      if (formProps.isValidating) {
        if (formProps.errors) {
          console.log(formProps.errors);
          if (isObjNotEmpty(formProps.errors)) {
            notification.info('Existem campos obrigatórios não preenchidos.', '')
          }
        }
      }
    }

  }, [formProps])

  useEffect(() => {


    getAllAcronimosPacote().then((response) => {
      if (response) {
        setAcronimos(response)
      }
    })

    getAllCrfContaContabil().then((response) => {
      if (response) {
        setContasContabil(response)
      }
    })

  }, [])

  return (
    <div spellCheck={true}>
      <DescricaoDoProjetoOuInvestimento />
      <MotivadorDoCapexNaoPrevisto />
      <Detalhes />
      <Orcamento list={list} setList={setList} orcamentos={orcamentos} setOrcamentos={setOrcamentos} acronimos={acronimos} contasContabil={contasContabil} />
      <OrcamentoFinanceiro list={list} setList={setList} orcamentos={orcamentos} setOrcamentos={setOrcamentos} acronimos={acronimos} contasContabil={contasContabil} />
      <RecursosParaExecucao />

      <Visibility visible={aprovacoesSolicitacao.length > 0} >
        <ValidacoesAprovacoes />
      </Visibility>
    </div>
  )
}

export default StepPreenchimentoTipoSolicitacao